import * as React from "react";
import ImageView from "../../../components/SmartImage";
import { LinkTargetType } from "../../../services/playground";
import { ZoomBox, ZoomCardBox, AnimationDuration } from "./styles.card";
import { ZoomContainer } from "./styles.index";
const { useEffect, useState } = React;
const ZoomCard = (props) => {
    const ZoomWrapRef = React.useRef(null);
    const [rollLen, setRollLen] = useState(0);
    const [isDraging, setDragState] = useState(false);
    const [countdown, setCountdown] = useState(AnimationDuration);
    let windowScrollTimeoutId;
    useEffect(() => {
        onScroll();
        return () => {
            if (!windowScrollTimeoutId) {
                return;
            }
            clearInterval(windowScrollTimeoutId);
        };
    });
    const onTransitionEnd = (e) => {
        if (e.target) {
            onScroll();
        }
    };
    const onTouchStart = () => {
        if (!isDraging) {
            setDragState(true);
        }
        if (!windowScrollTimeoutId) {
            return;
        }
        clearInterval(windowScrollTimeoutId);
    };
    const onTouchEnd = () => {
        if (isDraging) {
            setDragState(false);
        }
    };
    const onTouchCancel = () => {
        if (isDraging) {
            setDragState(false);
        }
    };
    const onScroll = () => {
        if (windowScrollTimeoutId) {
            clearInterval(windowScrollTimeoutId);
        }
        windowScrollTimeoutId = setInterval(() => {
            var _a;
            if (isDraging) {
                return;
            }
            if (!countdown) {
                const zoomWrapObj = ZoomWrapRef.current;
                if (!zoomWrapObj) {
                    return;
                }
                const zoomWrapRect = zoomWrapObj.getBoundingClientRect();
                if (zoomWrapObj.scrollWidth >
                    (((_a = zoomWrapObj.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) + Math.abs(zoomWrapRect.left)) {
                    setRollLen(rollLen + 1);
                }
                else {
                    setRollLen(0);
                }
                setCountdown(AnimationDuration);
            }
            else {
                setCountdown(countdown - 1);
            }
        }, 1000);
    };
    const { elements, placeholderBg, aTarget = LinkTargetType.Blank } = props;
    return (React.createElement(ZoomBox, { ref: ZoomWrapRef, style: {
            transform: `translate3d(calc((100vw - 1.4rem) * ${-rollLen}/4), 0 ,0)`,
            transitionDuration: `${rollLen ? 1000 : 0}ms`,
        }, onTouchStart: onTouchStart, onTouchCancel: onTouchCancel, onTouchEnd: onTouchEnd, onTransitionEnd: onTransitionEnd }, elements.map((element, i) => (React.createElement(ZoomCardBox, Object.assign({ key: i, isDraging: isDraging, onClick: e => {
            if (!element.link) {
                e.preventDefault();
            }
        } }, (element.link ? { href: element.link, target: aTarget } : {})),
        React.createElement(ImageView, { src: element.img, online: props.online, key: i, style: {}, placeholder: placeholderBg }))))));
};
const CubeBannerZoom = (props) => {
    const { positionId } = props;
    return (React.createElement(ZoomContainer, { id: positionId },
        React.createElement(ZoomCard, Object.assign({}, props, { online: props.online }))));
};
export default CubeBannerZoom;
